import { jsxs as e, jsx as o } from "react/jsx-runtime";

import r from "./MonthCalendar/index.js";

import t from "./NavControls.js";

import a from "./WeekCalendar/index.js";

import { useProviderSchedule as s } from "../../hooks/useProviderSchedule.js";

const d = d => {
    const {mode: m} = s();
    return e("div", {
        className: "flex flex-col gap-6",
        "data-testid": d["data-testid"],
        children: [ o(t, {}), o("month" === m ? r : a, {}) ]
    });
};

export { d as default };
//# sourceMappingURL=index.js.map
